import React from "react";
import "./Map.css";

const MyComponent = ({ name = "", address = "" }) => {
  return (
    <div className="googleMap2">
      <iframe
        title={`${name}'s map`}
        width="100%"
        height="300px"
        style={{ border: 0, position: "relative" }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_MAP_API}
    &q=${name}+${address}`}
      ></iframe>
    </div>
  );
};

export default MyComponent;
